const config = {
    projectId: 'wv3tmxuc',
    dataset: 'production',
    apiVersion: '2021-08-31'
}
export default config;